import { fetchCatalogueLevel, getLang } from "./correctiveActions";

/**
 * Catalogo de lo que se le puede enviar al denunciante.
 *
 * El primer nivel es el tipo, y las llaves deben existir tal cual en MSG-100:
 *  - `message`     : mensajes predisenados. El nombre corto va en `label` y el
 *                    TEXTO que se envia en `description`.
 *  - `infographic` : material precargado. El enlace va en `url`.
 *
 * Al denunciante solo se le puede enviar lo que este aqui: la escritura libre y
 * los adjuntos propios estan deshabilitados en esa conversacion.
 */
export const COMPLAINANT_MESSAGES_CATALOGUE = "MSG-100";

export const COMPLAINANT_BRANCHES = {
  MESSAGE: "message",
  INFOGRAPHIC: "infographic",
};

const localized = (value, locales, lang) => locales?.[lang] || value || "";

/**
 * Trae las opciones de una rama del catalogo.
 *
 * Devuelve [] cuando el tenant no tiene el catalogo o la rama esta vacia; la
 * pantalla lo trata como "no hay nada que enviar de este tipo".
 */
const fetchBranch = async (branchKey, lang) => {
  const branches = await fetchCatalogueLevel({
    catalogue: COMPLAINANT_MESSAGES_CATALOGUE,
  });
  const branch = branches.find((item) => item.key === branchKey);
  if (!branch) return [];

  const items = await fetchCatalogueLevel({
    catalogue: COMPLAINANT_MESSAGES_CATALOGUE,
    path: branch.path_locales,
  });

  return items.map((item) => ({
    value: item.path_locales,
    label: localized(item.label, item.locales, lang),
    // Solo una de las dos aplica segun la rama.
    text: localized(item.description, item.description_locales, lang),
    url: item.url || "",
  }));
};

/**
 * Mensajes predisenados: { value, label, text }. `text` es lo que recibe el
 * denunciante.
 */
export const getPredefinedMessages = async (lang = getLang()) => {
  const items = await fetchBranch(COMPLAINANT_BRANCHES.MESSAGE, lang);
  // Un mensaje sin texto no se puede enviar; se descarta para no ofrecerlo.
  return items.filter((item) => item.text.trim() !== "");
};

/**
 * Infografias: { value, label, url }. Se adjuntan como enlace, no se suben.
 */
export const getInfographics = async (lang = getLang()) => {
  const items = await fetchBranch(COMPLAINANT_BRANCHES.INFOGRAPHIC, lang);
  return items.filter((item) => item.url.trim() !== "");
};

/**
 * Shape con el que viajan los adjuntos del mensaje. El backend guarda el JSON
 * tal cual y ambos paneles (agente y denunciante) lo devuelven sin tocarlo,
 * porque solo resuelve contra Attachment las entradas con `attachments_file`.
 */
export const toMessageAttachment = (infographic) => ({
  filename: infographic.label,
  file_url: infographic.url,
});
